import React from "react"
import s from "./PartnersArea.module.css"
import ImageBanner from "../components/ImageBanner"
import content from "../data/pageContent.json"
import Header from "../components/Header"
import LoginForm from "../components/LoginForm"
import Footer from "../components/Footer"

const PartnersAreaLogin = () => {
  const page = content["partners-area-login"]

  return (
    <>
      <main>
        <ImageBanner
          wide={true}
          title={page.title}
          subtitle={page.subtitle}
          image={page.image}
        />

        <Header
          image={page.image}
          wide={true}
          title={page.title}
          subtitle={page.subtitle}
        ></Header>
        <div className={"body"}>
          <div className={"body-container"}>
            <LoginForm />
          </div>
        </div>
      </main>
      <Footer />
    </>
  )
}

export default PartnersAreaLogin
